import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MessageService } from 'primeng/api';
import { ApiService, parseApiErrorsToToast } from 'src/app/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-delete-channel-endpoint',
  templateUrl: './delete-channel-endpoint.component.html',
  styleUrls: ['./delete-channel-endpoint.component.scss']
})
export class DeleteChannelEndpointComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI | undefined;
  @Input() visible = false;
  @Input() endpointToBeRemoved: string | undefined;
  @Input() index: number |  undefined;
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  @Output() visibleChange: EventEmitter<any> = new EventEmitter();

  isLoading = false;
  isVam: boolean = false;
  isReviewer: boolean = false;
  isOps: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiService,
    private location: Location,
    private messageService: MessageService
  ) {
  }

  ngOnInit(): void {
    this.load();
  }

  async load() {
  }

  async delete() {
    try {
      this.blockUI?.start();

      console.log(`in DELETE to be removed = ${this.endpointToBeRemoved}`);

    } catch (err: any) {
      console.log(`${JSON.stringify(err)}`);
    } finally {
      
      this.onClose.emit(this.index);
      this.endpointToBeRemoved = '';
      this.index = 0;
      this.visible = false;
      this.visibleChange.emit(false);
      this.blockUI?.stop();
    }
  }
  async onCloseDialog() {
    this.endpointToBeRemoved = '';
    this.index = 0;
    console.log(`onCloseDialog  DONE`);
  }
}
